import * as THREE from 'three';
import { WebGPURenderer } from './WebGPURenderer';
import { Corps_room } from '../Corps_room';
import TWEEN from '@tweenjs/tween.js';
import { Camera } from './Camera';
import { Scene } from './Scene';
import { Env } from './Env';

export class Renderer {

    static renderer: WebGPURenderer;

    constructor() {
        Renderer.renderer = Renderer.setRenderer(Env.canvas);
    };

    static setRenderer(canvas: OffscreenCanvas, factor = 1, scene = Scene.scene, camera = Camera.camera): WebGPURenderer {
        const renderer = new WebGPURenderer({ antialias: true, alpha: true, canvas });
        // renderer.init();
        renderer.setPixelRatio(2); //(Math.min(Env.devicePixelRatio, 2))
        renderer.anisotropy = renderer.capabilities.getMaxAnisotropy();
        renderer.setSize(Env.canvas_size.width * factor, Env.canvas_size.height * factor, false);
        renderer.useLegacyLights = true;
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.autoUpdate = true;
        renderer.shadowMap.mapSize = renderer.capabilities.maxTextureSize/2;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.toneMapping = THREE.LinearToneMapping;
        renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
        renderer.info.autoReset = false;
        renderer.compile(scene, camera);
        renderer.render(scene, camera);
        renderer.info.reset();
        renderer.setAnimationLoop(Renderer.render);
        return renderer;
    }

    static render(): void {
        if (Renderer.animate.getRendererFlag()) {
            TWEEN.update();
            Camera.orbitControls.update();
            Corps_room.opacity.update();
            Renderer.renderer.render(Scene.scene, Camera.camera);
            Renderer.animate.update();
            Env.draw.update();
        }
    }

    static animate = {
        animateRendererFlag: 420,
        stopRenderer: false,
        setStopRenderer: function (bool: boolean): void {
            this.stopRenderer = bool;
            if (bool) {
                this.animateRendererFlag = 0;
            }
        },
        setRendererFlag: function (frame: number): void {
            if (!this.stopRenderer) {
                this.animateRendererFlag = this.animateRendererFlag < frame ? frame : this.animateRendererFlag;
            }
        },
        getRendererFlag: function (): number {
            return this.animateRendererFlag;
        },
        update: function (): void {
            if (this.animateRendererFlag > 0) {
                this.animateRendererFlag--;
            }
        }
    }

}